/**
 * Leitura das ferramentas de disparo da administracao.
 *
 * Rotas que o backend vai ter (docs/PLANO-PAINEL-COMPLETO.md, secao 2, linhas
 * "Admin · Disparos WhatsApp" e "Admin · Disparos E-mail"), todas so para
 * `platform_admin`:
 *
 *  - `GET /api/admin/broadcasts?companyId&from&to` -- envios em massa (de uma
 *    empresa ou de todas, sem `companyId`), totais do periodo anterior por
 *    empresa e canal, radar de oportunidades e total de opt-out. Aqui
 *    `companyId` VIAJA na query, ao contrario das rotas do lojista: a
 *    administracao opera em nome das empresas e o servidor confere o papel
 *    da sessao antes de responder. Em producao, com centenas de empresas, a
 *    lista vai paginada (`limit`/`offset` + filtros na query); a previa
 *    recorta no navegador.
 *  - `GET /api/admin/whatsapp/context?companyId` -- retrato de agora da
 *    empresa: numeros de saida, publicos pos-fato com historico, vendedoras
 *    de papel comercial, saude do numero, opt-out e tarifas.
 *  - `GET /api/admin/templates?channel=whatsapp` -- resumo dos modelos.
 *  - `GET /api/admin/email-campaigns?from&to` -- campanhas de e-mail de todas
 *    as empresas, dominios, automacoes, descadastros e periodo anterior.
 *
 * Em modo real, ate as rotas nascerem, a chamada cai em `ErrorPanel` (404) --
 * nunca em numero inventado. Toda escrita (iniciar, pausar, agendar, criar
 * campanha) fica em estado local na previa (GUIA-PAINEL, secao 3).
 */

import { fetchOrSimulate, rangeQuery, type Envelope } from '../../lib/api';
import type { PeriodRange } from '../../types';
import { simularCampanhasEmail, simularContextoWhatsApp, simularDisparos, simularModelos } from './mock';
import type { BroadcastsData, EmailCampaignsData, MessageTemplateSummary, WhatsAppContext } from './types';

export function fetchBroadcasts(companyId: string | null, range: PeriodRange, signal: AbortSignal): Promise<Envelope<BroadcastsData>> {
  return fetchOrSimulate('/api/admin/broadcasts', { ...rangeQuery(range), companyId }, signal, () => simularDisparos(companyId, range));
}

export function fetchWhatsAppContext(companyId: string, signal: AbortSignal): Promise<Envelope<WhatsAppContext>> {
  return fetchOrSimulate('/api/admin/whatsapp/context', { companyId }, signal, () => simularContextoWhatsApp(companyId));
}

export function fetchTemplatesSummary(signal: AbortSignal): Promise<Envelope<readonly MessageTemplateSummary[]>> {
  return fetchOrSimulate('/api/admin/templates', { channel: 'whatsapp' }, signal, () => simularModelos());
}

export function fetchEmailCampaigns(range: PeriodRange, signal: AbortSignal): Promise<Envelope<EmailCampaignsData>> {
  return fetchOrSimulate('/api/admin/email-campaigns', rangeQuery(range), signal, () => simularCampanhasEmail(range));
}
